import PouchDB from 'pouchdb'
import { LastErrorStore } from '@/stores'

const DB_LAST_LOGGUED_ID = 'last_loggued'

/**
 * Manage access to local db, used to store some persistent informations
 */
class DatabaseService {
  /**
   * Construtor. No parameter
   */
  constructor () {
    this._db = new PouchDB('lynx_mobile_db')
  }

  /**
   * Retrieve last stored login and base 64 encoded password.
   * @returns a structure with login and encodedpassword, null if never stored or if error.
   * An error is published if error other than not found.
   */
  async getLoginAndPassword () {
    try {
      const existingDoc = await this._db.get(DB_LAST_LOGGUED_ID)
      return {login: existingDoc.login, encodedpassword: existingDoc.encodedpassword}
    } catch (err) {
      if (err.name !== 'not_found') {
        LastErrorStore().NotifyError(err)
      }
      return null
    }
  }

  /**
   * Store the login and encoded password in the local DB.
   * @param {string} login login
   * @param {string} encodedpassword Base 64 encoded password
   * @returns true is save ok, false otherwise
   */
  async saveLoginAndPassword (login, encodedpassword) {
    const loginInfo = {
      _id: DB_LAST_LOGGUED_ID,
      login: login,
      encodedpassword: encodedpassword
    }
    try {
      try {
        const existingDoc = await this._db.get(DB_LAST_LOGGUED_ID)
        loginInfo._rev = existingDoc._rev // Nécessaire pour mettre à jour un document existant
      } catch (err) {
        if (err.name !== 'not_found') {
          LastErrorStore().NotifyError(err)
        }
      }
      // Stocker le document dans la base de données
      const response = await this._db.put(loginInfo)
      return response.ok
    } catch (err) {
      LastErrorStore().NotifyError(err)
    }
    return false
  }

  async saveFilter (type, filterdata) {
    const filterinfo = {
      _id: type,
      filter: JSON.stringify(filterdata)
    }
    try {
      try {
        const existingDoc = await this._db.get(type)
        filterinfo._rev = existingDoc._rev // Nécessaire pour mettre à jour un document existant
      } catch (err) {
        if (err.name !== 'not_found') {
          LastErrorStore().NotifyError(err)
        }
      }
      // Stocker le document dans la base de données
      const response = await this._db.put(filterinfo)
      return response.ok
    } catch (err) {
      LastErrorStore().NotifyError(err)
    }
    return false
  }

  async loadFilter (type) {
    try {
      const existingDoc = await this._db.get(type)
      return JSON.parse(existingDoc.filter)
    } catch (err) {
      if (err.name !== 'not_found') {
        LastErrorStore().NotifyError(err)
      }
      return {}
    }
  }
}

/**
 * Singleton for the whole app
 */
export const DatabaseServiceInstance = new DatabaseService()
